export const SIGN_DOCUMENTS_ACTION_MODAL = 'SignDocumentsActionModal' as const;
export const VIEW_SIGNED_DOCUMENTS_MODAL = 'ViewSignedDocumentModal' as const;
export const VIEW_GUARANTOR_AGREEMENT_MODAL =
    'ViewGuarantorAgreementModal' as const;
export const ADD_PAYMENT_METHOD_MODAL = 'AddPaymentMethodModal' as const;
export const EDIT_PAYMENT_METHOD_MODAL = 'EditPaymentMethodModal' as const;
export const REPAYMENT_SCHEDULE_MODAL = 'RepaymentScheduleModal' as const;
export const PERSON_MODAL = 'PersonModal' as const;
export const PROCESSING_PAYMENT_MODAL = 'ProcessingPaymentModal';
export const MANUAL_PAYMENT_MODAL = 'ManualPaymentModal';
export const TIMEOUT_SESSION_ERROR_MODAL = 'TimeoutSessionErrorModal';
export const FALLBACK_ERROR_MODAL = 'FallbackErrorModal';
export const UPLOAD_DOCUMENTS_MODAL = 'UploadDocumentsModal';
export const ONFIDO_VERIFICATION_MODAL = 'IdCheckVerificationModal';
export const LINK_OPEN_BANKING_MODAL = 'LinkOpenBankingModal';
export const HELP_MODAL = 'HelpModal';
